import constants from '@/lib/constants.js'
import moment from 'moment/src/moment'
import _config from '@/config.js'

let config = _config[process.env.VUE_APP_CONFIG || 'development']

export default {
  constants: constants,
  data() {
    return {
      constants: constants,
      config: config
    }
  },
  filters: {
    date: function(v) {
      if (!v) {
        return ''
      }

      try {
        return moment(v.toDate()).format('DD/MM/YY')
      } catch(err) {
        return moment(v).format('DD/MM/YY')
      }
    },
    datetime: function(v) {
      if (!v) {
        return ''
      }

      try {
        return moment(v.toDate()).format('HH:mm:ss DD/MM/YY')
      } catch(err) {
        return moment(v).format('HH:mm:ss DD/MM/YY')
      }
    },
    capitalise: function(v) {
      return v.charAt(0).toUpperCase() + v.slice(1)
    },
    pluralise: function(v) {
      return v + 's'
    }
  },
}
